








































import Vue from "vue";
import store from "@/store";

// Interfaces
import { dialogOptions } from "@/interfaces/dialog.interface";
import { userWorkoutTemplate } from "@/interfaces/user.interface";
import { WorkoutTemplate } from "@/interfaces/workoutTemplate.interface";
import { generateEmptyWorkout, Workout } from "@/interfaces/workout.interface";

// Components
import CurrentWorkoutCard from "@/components/CurrentWorkoutCard.vue";
import WorkoutTemplateCard from "@/components/WorkoutTemplateCard.vue";

// Dialogs
import WorkoutTemplateDialog from "@/components/dialogs/WorkoutTemplateDialog.vue";

export default Vue.extend({
  data: () => ({
    overlayLoader: false,

    // Dialogs
    workoutTemplateDialog: false,

    // Workout Template
    workoutTemplateData: Object() as WorkoutTemplate,
  }),
  methods: {
    dialogController(dialogToBeOpen: dialogOptions) {
      this.workoutTemplateDialog = false;
      if (dialogToBeOpen === "workoutTemplateDialog")
        this.workoutTemplateDialog = true;
    },
    startEmptyWorkout() {
      store.commit("workoutStore/setCurrentWorkout", generateEmptyWorkout());
      store.commit("workoutStore/changeCurrentWorkoutDialogCollapse", true);
    },
    startEmptyTemplateDialog() {
      this.dialogController("workoutTemplateDialog");
    },
  },
  computed: {
    allWorkoutTemplateData(): userWorkoutTemplate[] {
      return store.getters["templateStore/getUserTemplatesByDate"];
    },
    isUserCurrentlyWorkingOut(): boolean {
      return store.getters["workoutStore/isUserCurrentlyWorkingOut"];
    },
    getCurrentWorkout(): Workout | null {
      return store.getters["workoutStore/getCurrentWorkout"];
    },
  },
  components: {
    WorkoutTemplateCard,
    WorkoutTemplateDialog,
    CurrentWorkoutCard,
  },
});
